import React, {useCallback, useEffect, useMemo, useState} from 'react'
import TriggerNode from './nodes/TriggerNode'
import SendMessageNode from './nodes/SendMessageNode'
import TimeDelayNode from './nodes/TimeDelayNode'
import AutomationFlow from './AutomationFlow'
import ConditionalSplitNode from './nodes/ConditionalSplitNode'
import {useParams} from 'react-router-dom'
import {AutomationData} from '../../../Utils/Constant/automationData'

const FlowWrapper = () => {
  const {id} = useParams()
  const [initialNodes, setInitialNodes] = useState<any>([])
  const [initialEdges, setInitialEdges] = useState<any>([])
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    if (!!id) {
      const findData = AutomationData?.find((data) => data.id === id)
      setInitialNodes(findData?.data?.nodes)
      setInitialEdges(findData?.data?.edges)
      setIsLoading(false)
    }
  }, [id])

  const nodeTypes = {
    trigger: TriggerNode,
    sendMessage: SendMessageNode,
    timeDelay: TimeDelayNode,
    conditionalSplit: ConditionalSplitNode,
  }

  return (
    <>
      {isLoading ? null : (
        <AutomationFlow
          initialNodes={initialNodes}
          initialEdges={initialEdges}
          nodeTypes={nodeTypes}
        />
      )}
    </>
  )
}

export default FlowWrapper
